import { useSiteContext } from '../iwQueryClient/useSiteContext';

export function useIsInSelfServeSplitTest() {
    const siteContext = useSiteContext();
    return siteContext.data?.is_eligible_for_no_ops_contact_split;
}
